
/* Reused partials */
export const video = () => [
	'*',
	{
		poster: image(),
		video_files: [
			{
				directus_files_id: image()
			}
		]
	}
]

export const allThumbnailMedia = () => ({
	featured_image: image(),
	thumbnail_image: image(),
	thumbnail_video: video()
})

export const workLink = () => [
	'title',
	'slug',
	'display_title',
	'intro',
	'client',
	'client_link',
	'year',
	'foreground_color',
	'cursor_background_color',
	'cursor_foreground_color',
	'details_color',
	'override_thumbnail_image',
	allThumbnailMedia()
]

/* Fields */

export function getTopLevelFields() {
	return [
		'*',
		{
			item: [
				'*',
			]
		}
	]
}

export function image(type) {
	if (type === 'all') {
		return ['*']
	} else {
		return [
			'id',
			'description',
			'type',
			'width',
			'height',
			'modified_on'

		]
	}
}

export function getFormFields() {
	return {
		fields: [
			'*',
			{
				elements: getTopLevelFields()
			}
		]
	}
}

export function getInternalLinkFields() {
	return {
		fields: getTopLevelFields()
	}
}

